import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import useSeriesFields from './useSeriesField';

const useSeriesColors = () => {
    const theme = useTheme();
    const { currentMonth, lastMonth } = useSeriesFields();

    return useMemo(
        () => ({
            [currentMonth]: theme.dashboardTheme?.chartColor?.[0],
            [lastMonth]: theme.dashboardTheme?.chartColor?.[1],
        }),
        [theme, currentMonth, lastMonth]
    );
};

export default useSeriesColors;
